import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import './Card.css';

export default function ImageGen() {
  const { token, hasApiKey } = useOutletContext();
  const [prompt, setPrompt] = useState('A futuristic cityscape at night with neon lights');
  const [orientation, setOrientation] = useState('landscape');
  const [status, setStatus] = useState('');
  const [imageUrl, setImageUrl] = useState(null);

  const generate = async () => {
    setStatus('Generating...');
    try {
      const res = await fetch('/api/generate-image', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ prompt, orientation })
      });
      if (!res.ok) throw new Error(await res.text());
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setImageUrl(url);
      setStatus('Done!');
    } catch (err) {
      setStatus(`Error: ${err.message}`);
    }
  };

  return (
    <div className="card">
      <div className="card-title">
        <i className="fas fa-image"></i> Image Generation
      </div>
      <label>Prompt</label>
      <input value={prompt} onChange={e => setPrompt(e.target.value)} />
      <select value={orientation} onChange={e => setOrientation(e.target.value)}>
        <option value="landscape">Landscape</option>
        <option value="portrait">Portrait</option>
      </select>
      <button onClick={generate} disabled={!hasApiKey}>Generate Image</button>
      <div className="status-badge">{status}</div>
      {imageUrl && <img src={imageUrl} className="preview-img" alt="Generated" />}
    </div>
  );
}
